module.exports = __webpack_public_path__ + "static/img/ultra.38f8963.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ultra.png
// module id = E9hH
// module chunks = 0